import React, { useEffect, useState } from "react";

const useUpdateDetails = (old) => {
  const [changes, setChanges] = useState([]);
  const [oldObjects, setOldObjects] = useState(null);

  useEffect(() => {
    if (old) {
      setOldObjects(old);
    }
  }, []);

  function addChange(change) {
    setChanges([...changes, change]);
  }

  function saveChanges() {
    // Save changes to database
    // If successful, clear changes
    setChanges([]);
  }

  return { changes, addChange, saveChanges, setOldObjects };
};

export default useUpdateDetails;
